import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-8 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:justify-between gap-10">
          <div className="max-w-sm">
            <Link to="/" className="flex items-center gap-2 cursor-pointer whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-film-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-black tracking-wide text-background-50">同学的妈妈</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-background-300 font-body">
              同学的妈妈影视大全专注电视剧与电影的剧情介绍及影视资讯，帮助观众发现热门作品、了解详细剧情、获取最新影视动态。站内全部内容均为虚构演示数据，不提供在线播放与下载服务。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 text-sm">
            <div>
              <h4 className="font-label font-bold text-background-50 mb-3">内容导航</h4>
              <ul className="space-y-2 text-background-300">
                <li><Link to="/category/tv" className="hover:text-accent-400 cursor-pointer whitespace-nowrap">电视剧</Link></li>
                <li><Link to="/category/movie" className="hover:text-accent-400 cursor-pointer whitespace-nowrap">电影</Link></li>
                <li><Link to="/news" className="hover:text-accent-400 cursor-pointer whitespace-nowrap">影视资讯</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-label font-bold text-background-50 mb-3">关于我们</h4>
              <ul className="space-y-2 text-background-300">
                <li><Link to="/about" className="hover:text-accent-400 cursor-pointer whitespace-nowrap">关于网站</Link></li>
                <li><a href="mailto:hello@tongxuedemama.com" className="hover:text-accent-400 cursor-pointer whitespace-nowrap">联系邮箱</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-label font-bold text-background-50 mb-3">热门题材</h4>
              <ul className="space-y-2 text-background-300">
                <li><Link to="/category/tv/family" className="hover:text-accent-400 cursor-pointer whitespace-nowrap">家庭伦理剧</Link></li>
                <li><Link to="/category/movie/hot" className="hover:text-accent-400 cursor-pointer whitespace-nowrap">年度热门电影</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2026 同学的妈妈影视大全 版权所有，站内内容均为虚构演示，不代表真实影视发行信息。</p>
          <p>本站不提供任何视频播放、下载及转载服务</p>
        </div>
      </div>
    </footer>
  );
}